var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHvac({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.295 20.06C15.295 20.06 17.2483 21.5877 19.7629 21.5877C22.2775 21.5877 33.2114 15.5771 36.3899 15.5771C39.5684 15.5771 41.6713 18.5824 41.6713 18.5824",
    stroke: "#FF543F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.295 29.9776C15.295 29.9776 17.2483 31.5053 19.7629 31.5053C22.2775 31.5053 33.2114 25.4947 36.3899 25.4947C39.5684 25.4947 41.6713 28.5 41.6713 28.5",
    stroke: "#9972BB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.295 39.8951C15.295 39.8951 17.2483 41.4228 19.7629 41.4228C22.2775 41.4228 33.2114 35.4122 36.3899 35.4122C39.5684 35.4122 41.6713 38.4175 41.6713 38.4175",
    stroke: "#4A90E2",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHvac);
export default __webpack_public_path__ + "static/media/HVAC.33af5ccc82f9b0c88bfc322ec5847791.svg";
export { ForwardRef as ReactComponent };